var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box"},[_c('p',[_vm._v("©2021-"+_vm._s(_vm.runTime.year))]),_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._m(0),_c('p',[_vm._v("本网站勉强运行"+_vm._s(_vm.runTime.days)+"天")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("备:"),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer","alt":"渝ICP备2023001910号"}},[_vm._v("渝ICP备2023001910号")])])
}]

export { render, staticRenderFns }